<script>
import {mapGetters, mapActions} from 'vuex'
export default {
	components: {
		IndicationsView: () => import('@/components/evaluations/IndicationsView.vue'),
		QuizView: () => import('@/components/evaluations/QuizView.vue'),
		QuizEnd: () => import('@/components/evaluations/QuizEnd.vue')
	},

	data() {
		return {
			running: false,
			queueQuestions: [],
			historyQuestions: [],
			rescueQuestion: null,
			skipQuestion: null,
			pointsQuestion: 100/10,
			comodin50: true,
			comodinRescue: true,
			prevQuestion: null,
			completed: false
		}
	},

	computed: {
		question() {
			return this.queueQuestions[Math.floor(Math.random()*this.queueQuestions.length)]
		},
		activity() {
			let activity = this.progressById(Number(this.$route.params.activity))
			if(!activity) {
				activity =  this.activityById(Number(this.$route.params.activity))
			}
			return activity
		},
		evaluation() {
			return this.evaluationByActivity(Number(this.$route.params.activity))
		},

		evaluationIndex() {
			return this._evaluationIndex(Number(this.$route.params.activity))
		},

		evaluationTries() {
			return this.getEvaluationTries(Number(this.$route.params.activity))
		},

		canTakeEvaluation() {
			return this.checkCanTakeEvaluation(Number(this.$route.params.activity))
		},
		assertAnswers() {
			return this.historyQuestions.filter(q => q.assert)
		},
		...mapGetters({
			activityById: 'activities/byId',
			progressById: 'auth/progressById',
			evaluationByActivity: 'evaluations/evaluationByActivity',
			_evaluationIndex: 'evaluations/evaluationIndex',
			userId: 'auth/userId',
			getEvaluationTries: 'auth/evaluationTries',
			checkCanTakeEvaluation: 'auth/canTakeEvaluation',
			activityViewed: 'auth/activityViewed',
			activityCompleted: 'auth/activityCompleted',
			
		})
	},

	watch: {
		'evaluation.questions': {
			handler(nVal) {
				if(!nVal.length) {
					return
				}
				let questions = nVal.map(v => Object.assign({}, v)).sort(function(){return 0.5 - Math.random()})
				this.queueQuestions = questions.slice(0, 10)
				this.rescueQuestion = questions[10]
				// this.$set(this, 'rescueQuestion', questions[10])
			},
			deep: true,
			immediate: true
		}
	},

	methods: {
		handlerStart() {
			if(this.canTakeEvaluation) {
				this.comodin50 = true
				this.comodinRescue = true
				this.running = true
				this.curentQuestion = 1
				let questions = this.evaluation.questions.map(v => Object.assign({}, v)).sort(function(){return 0.5 - Math.random()})
				this.queueQuestions = questions.slice(0, 10)
				this.rescueQuestion = questions[10]
				this.historyQuestions = []
				this.saveProgress(
					Object.assign(
						{...this.activity}, 
						{
							evaluationTries: (this.evaluationTries + 1),
							userId: this.userId,
							completed: this.activityCompleted(Number(this.$route.params.activity)),
							viewed: this.activityViewed(Number(this.$route.params.activity)),
						}
					)
				)

			}
		},

		onNextQuestion(data) {
			this.validateAnswer(data)
		},

		onPrevQuestion(data) {
			this.prevQuestion = this.historyQuestions[this.historyQuestions.length - data]
		},

		validateAnswer(data) {
			let questionIndex = this.queueQuestions.findIndex(q => q.id === data.id)
			let question = Object.assign({}, this.queueQuestions[questionIndex])
			question.assert = false
			if(question.answers.includes(data.answer)) {
				question.assert = true
			}
			question.resolve = data.answer
			this.queueQuestions.splice(questionIndex, 1)
			this.historyQuestions.push(question)
			if(!this.queueQuestions.length) {
				this.completedQuiz()
			}
		},

		async completedQuiz() {
			this.completed = true
			this.running = false
			let activity = {...this.activity}
			let points = (this.assertAnswers.length * this.pointsQuestion)
			activity.evaluation = Object.assign({...this.evaluation}, {results: [...this.historyQuestions]})
			activity.completed = (points >= 80) || this.activityCompleted(Number(this.$route.params.activity)) || this.evaluationTries > 2,
			activity.viewed = this.activityViewed(Number(this.$route.params.activity)),
			activity.evaluationTries = this.evaluationTries
			activity.evaluationPoints = points

			window._SCORM.set(`cmi.objectives.${this.evaluationIndex}.score.raw`, points)
			window._SCORM.set(`cmi.objectives.${this.evaluationIndex}.status`, activity.completed ? 'passed' : 'failed')
			window._SCORM.save()
			
			// if(!activity.completed && activity.evaluationTries == 2) {
			// 	// this.resetActivity()
			// 	activity.viewed = false
			// }
			
			await this.saveProgress(Object.assign({...activity}, {userId: this.userId}))
		},

		resetActivity() {
			let activity = this.activityById(Number(this.$route.params.activity))
			let module = this.$route.params.module

			let name = this.userId + activity.activityId + activity.url
			delete localStorage[name]

		},

		onUseComodin50() {
			this.comodin50 = false
		},

		onUseComodinRescue(questionId) {
			this.comodinRescue = false
			let questions = this.queueQuestions.map(q => Object.assign({}, q))
			let questionIndex = questions.findIndex(q => q.id === questionId)
			let question = questions[questionIndex]
			this.$set(this, 'skipQuestion', question)
			this.queueQuestions.splice(questionIndex, 1)
			this.queueQuestions.push(Object.assign({}, this.rescueQuestion))
		},

		...mapActions({
			saveProgress: 'auth/saveUserProgress'
		})
	}
}
</script>
<template>
	<div  class="evaluation">
		<QuizView v-if="running"
		:key="`quiz_quiestion_view-${question.id}`" 
		:comodin50="comodin50" 
		:comodin-rescue="comodinRescue" 
		:score="assertAnswers.length * pointsQuestion" 
		:question="prevQuestion || question"
		:count="queueQuestions.length + historyQuestions.length"
		:number="historyQuestions.length + 1"
		@useComodin50="onUseComodin50"
		@useComodinRescue="onUseComodinRescue"
		@prevQuestion="onPrevQuestion"
		@nextQuestion="onNextQuestion"/>
		
		<IndicationsView v-else-if="!running && !evaluationTries" 
		@start="handlerStart" 
		:title="evaluation.title" 
		:description="evaluation.description" 
		:module="activity.title"/>
	
		<QuizEnd v-else 
		@start="handlerStart" 
		:activity="activity"
		:tries="evaluationTries"
		:can-take-evaluation="canTakeEvaluation"
		:completed="activityCompleted(Number($route.params.activity))"
		:points="(assertAnswers.length * pointsQuestion) || (activity.evaluationPoints || 0)"
		/>
		<!-- <pre>{{question}}</pre> -->
		<footer class="evaluation__footer">
			<img src="@/assets/img/logo_blanco_tag.png" alt="">
		</footer>
	</div>
</template>
<style  lang="scss" scoped>
.evaluation{
	margin-left: 90px;
	height: 100%;
	overflow: auto;
	position: relative;
	.wrapper{
		min-height: calc(100% - 60px);
	}
	footer{
		width: 100%;
		overflow: hidden;
		height: 60px;
		background-color: #00143F;
		padding: 0.5rem;
		text-align: right;
		position: sticky;
		bottom: 0;
		left: 0;
		// width: 100%;
		img{
			height: 100%;
		}
	}
}
</style>